<template>
    <AdminLayout :crumbs="[{ label: 'Usuarios' }]">
        <div class="a-page-head">
            <div>
                <h1 class="a-page-title">Usuarios</h1>
                <p class="a-page-subtitle">El equipo organizador y quién está conectado ahora mismo.</p>
            </div>
            <div class="a-page-actions" v-if="is_admin">
                <div class="dropdown">
                    <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-broadcast-pin"></i>Acciones en bloque</button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><h6 class="dropdown-header">Equipos</h6></li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="ask_bulk('CLIENT_RELOAD_ALL', 'PLAYER', 'Recargar la pantalla de todos los equipos')"><i class="bi bi-arrow-clockwise"></i>Recargar pantallas</a></li>
                        <li><a class="dropdown-item text-danger" href="javascript:void(0)" @click="ask_bulk('CLIENT_KICK_ALL', 'PLAYER', 'Expulsar a todos los equipos')"><i class="bi bi-box-arrow-right"></i>Expulsar a todos</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><h6 class="dropdown-header">Pantallas grandes (manager)</h6></li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="ask_bulk('CLIENT_RELOAD_ALL', 'MANAGER', 'Recargar todas las pantallas grandes')"><i class="bi bi-arrow-clockwise"></i>Recargar</a></li>
                        <li><a class="dropdown-item text-danger" href="javascript:void(0)" @click="ask_bulk('CLIENT_KICK_ALL', 'MANAGER', 'Desconectar todas las pantallas grandes')"><i class="bi bi-box-arrow-right"></i>Desconectar</a></li>
                    </ul>
                </div>
                <button type="button" class="btn btn-primary" @click="open_add"><i class="bi bi-person-plus"></i>Añadir organizador</button>
            </div>
        </div>

        <div class="a-card mb-4">
            <div class="a-card-header">
                <h2 class="a-section-title">Equipo organizador</h2>
                <span class="a-subtle">{{ staff.length }} cuentas</span>
            </div>
            <ul class="a-list">
                <li v-for="u in staff" :key="u.id" class="a-row a-row-link" @click="$refs.user.open(u.uuid)">
                    <div class="u-avatar">{{ (u.username || '?').charAt(0).toUpperCase() }}</div>
                    <div class="a-row-main">
                        <div class="a-row-title">{{ u.username }} <span v-if="me && me.id == u.id" class="a-subtle">(tú)</span></div>
                        <div class="a-row-meta"><span>{{ role_label(u.role) }}</span></div>
                    </div>
                    <span class="a-pill" :class="is_online(u) ? 'a-pill-ok' : 'a-pill-muted'">{{ is_online(u) ? 'Conectado' : 'Fuera' }}</span>
                    <i class="bi bi-chevron-right a-muted"></i>
                </li>
            </ul>
        </div>

        <div class="a-card">
            <div class="a-card-header">
                <div>
                    <h2 class="a-section-title">Conectados ahora</h2>
                    <div class="a-subtle" v-if="room_name">En {{ room_name }}</div>
                </div>
                <div class="a-search" style="max-width: 260px; flex: 1">
                    <i class="bi bi-search"></i>
                    <input type="search" class="form-control" v-model="search" placeholder="Buscar">
                </div>
            </div>
            <ul class="a-list" v-if="connected.length">
                <li v-for="c in connected" :key="c.uuid" class="a-row a-row-link" @click="$refs.user.open(c.uuid)">
                    <span class="jersey" :style="{ backgroundColor: (c.avatar_style && c.avatar_style.color) || 'var(--a-line-strong)' }"></span>
                    <div class="a-row-main">
                        <div class="a-row-title">{{ c.role == utils.USER_ROLES.GUEST ? 'Sin identificar' : c.username }}</div>
                        <div class="a-row-meta">
                            <span>{{ c.role == utils.USER_ROLES.GUEST ? 'Eligiendo equipo' : view_label(c.current_view) }}</span>
                            <span v-if="c.device && c.device.client">{{ c.device.client.name }} · {{ c.device.os && c.device.os.name }}</span>
                        </div>
                    </div>
                    <span class="a-tag">{{ role_label(c.role) }}</span>
                    <i class="bi bi-chevron-right a-muted"></i>
                </li>
            </ul>
            <div v-else class="a-empty py-4">{{ search ? 'Nadie coincide con la búsqueda.' : 'No hay nadie conectado.' }}</div>
        </div>

        <!-- Add staff account -->
        <div class="modal fade a-modal" ref="addModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-if="new_user">
                    <div class="modal-header">
                        <h1 class="modal-title">Añadir organizador</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label class="form-label" for="nu-name">Usuario</label>
                            <input id="nu-name" type="text" class="form-control" v-model="new_user.username" autocomplete="off">
                        </div>
                        <div class="mb-3">
                            <label class="form-label" for="nu-role">Rol</label>
                            <select id="nu-role" class="form-select" v-model="new_user.role">
                                <option :value="utils.USER_ROLES.ADMINISTRATOR">Administrador · puede editarlo todo</option>
                                <option :value="utils.USER_ROLES.ASSISTANT">Asistente · ve el panel, no edita</option>
                                <option :value="utils.USER_ROLES.MANAGER">Pantalla grande (manager)</option>
                            </select>
                        </div>
                        <div class="row g-3">
                            <div class="col-6">
                                <label class="form-label" for="nu-pass">Contraseña</label>
                                <input id="nu-pass" type="password" class="form-control" v-model="new_user.password" autocomplete="new-password">
                            </div>
                            <div class="col-6">
                                <label class="form-label" for="nu-pass2">Repítela</label>
                                <input id="nu-pass2" type="password" class="form-control" v-model="new_user.repassword" autocomplete="new-password">
                            </div>
                            <div class="col-12 form-text mt-1">Mínimo 6 caracteres.</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="add">Crear cuenta</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bulk confirmation -->
        <div class="modal fade a-modal" ref="bulkModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-if="bulk">
                    <div class="modal-header">
                        <h1 class="modal-title">{{ bulk.title }}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body">Afecta a todos los conectados con ese rol. ¿Seguro?</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger" @click="run_bulk">Sí, hacerlo</button>
                    </div>
                </div>
            </div>
        </div>

        <UserDetailModal ref="user" />
    </AdminLayout>
</template>

<script>
import { Modal } from 'bootstrap'
import utils from '@/../../shared/utils'
import AdminLayout from '@/components/admin/AdminLayout.vue'
import UserDetailModal from '@/components/admin/UserDetailModal.vue'
import { role_label, view_label } from '@/utils/admin-format'

const STAFF_ROLES = [utils.USER_ROLES.SUPER_ADMINISTRATOR, utils.USER_ROLES.ADMINISTRATOR, utils.USER_ROLES.ASSISTANT, utils.USER_ROLES.MANAGER];

export default {
    name: 'Users',
    components: { AdminLayout, UserDetailModal },
    data(){
        return { utils, search: '', new_user: null, bulk: null };
    },
    computed: {
        game(){ return this.$store.state.game; },
        me(){ return this.game.user; },
        is_admin(){ return !!this.me && this.me.role == utils.USER_ROLES.ADMINISTRATOR; },
        staff(){
            const seen = new Set();
            return (this.game.users || []).concat(this.game.clients || [])
                .filter((u) => STAFF_ROLES.includes(u.role) && u.id != null && !seen.has(u.id) && seen.add(u.id))
                .sort((a, b) => a.role - b.role || (a.username || '').localeCompare(b.username || ''));
        },
        // One row per person even if they have several tabs/devices open.
        connected(){
            const term = this.search.trim().toLowerCase();
            const seen = new Set();
            return (this.game.clients || []).filter((c) => {
                const key = c.id != null ? 'u' + c.id : c.uuid;
                if(seen.has(key)) return false;
                seen.add(key);
                return (c.username || '').toLowerCase().includes(term);
            });
        },
        room_name(){
            const s = (this.game.seasons || []).find((x) => x.id == this.game.active_season_id);
            return s ? s.name : null;
        }
    },
    mounted(){
        this.add_modal = new Modal(this.$refs.addModal);
        this.bulk_modal = new Modal(this.$refs.bulkModal);
    },
    beforeUnmount(){
        this.add_modal.dispose();
        this.bulk_modal.dispose();
    },
    methods: {
        role_label, view_label,
        is_online(u){ return (this.game.clients || []).some((c) => c.id == u.id); },
        open_add(){
            this.new_user = { username: '', role: utils.USER_ROLES.ADMINISTRATOR, avatar: 1, password: '', repassword: '' };
            this.add_modal.show();
        },
        add(){
            const u = this.new_user;
            if(!utils.is_valid_parameter(u.username) || !u.password){
                window.toast.error('Usuario y contraseña son obligatorios.');
                return;
            }
            if(u.password != u.repassword){
                window.toast.error('Las contraseñas no coinciden.');
                return;
            }
            if(u.password.length < 6){
                window.toast.error('La contraseña necesita al menos 6 caracteres.');
                return;
            }
            window.network.wso.send(JSON.stringify({ action: window.RPC.CLIENT_REGISTER, params: u }));
            this.add_modal.hide();
        },
        ask_bulk(rpc, role, title){
            this.bulk = { rpc, role, title };
            this.bulk_modal.show();
        },
        run_bulk(){
            window.network.wso.send(JSON.stringify({ action: window.RPC[this.bulk.rpc], params: { role: utils.USER_ROLES[this.bulk.role] } }));
            this.bulk_modal.hide();
        }
    }
}
</script>

<style scoped>
.u-avatar{
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: var(--a-ink);
    color: #fff;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.jersey{
    width: 14px;
    height: 32px;
    border-radius: 4px;
    flex-shrink: 0;
}
</style>
